import { createBrowserHistory } from 'history'
import qs, { ParsedQs } from 'qs'

export const browserHistory = createBrowserHistory()

/*
 * keys: array of string
 */
export function stripQueryString(keys: string[]): void {
  const { location: browserLocation } = browserHistory
  const { search: queryString } = browserLocation
  if (queryString.length <= 1) {
    return
  }
  const queryParams = parseQueryString(queryString)
  const strippedQueryParams = keys.reduce(
    (params, key) => Object.assign(params, { [key]: undefined }),
    queryParams,
  )

  const strippedQueryString = stringifyQueryString(strippedQueryParams, true)
  if (queryString !== strippedQueryString) {
    browserHistory.replace({
      pathname: browserLocation.pathname,
      search: strippedQueryString,
      hash: browserLocation.hash,
    })
  }
}

export function parseQueryString(queryString?: string): ParsedQs {
  return qs.parse(queryString || browserHistory.location.search, {
    ignoreQueryPrefix: true,
  })
}

export function stringifyQueryString(
  queryParams: ParsedQs,
  addQueryPrefix = false,
): string {
  return qs.stringify(queryParams, { addQueryPrefix })
}

/*
 * keys: array of string
 */
export function takeQueryParams(keys: string[]): ParsedQs {
  const queryParams = parseQueryString()
  const filteredQueryParams = keys.reduce((params, key) => {
    params[key] = queryParams[key]
    return params
  }, {} as ParsedQs)
  stripQueryString(keys)
  return filteredQueryParams
}
